import { round } from "lodash";

import { Divider, Progress } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import { useCollectionData } from "astrid-firestore/src/hooks";

import Flex from "../../../../../components/Flex/Flex";
import getStudioHours from "../../../../productions/utils/getStudioHours";
import ImageAvatar from "../../../../ui/components/ImageAvatar/ImageAvatar";
import Toast from "../../../../ui/components/Toast/Toast";
import themeColors from "../../../../ui/constants/themeColors";
import truncateString from "../../../../ui/utils/truncateString";

const User = ({ user }) => {
	return (
		<Flex justifyContent="flex-start" gap={5}>
			<ImageAvatar src={user.img} style={{ width: 28, height: 28 }} />

			<div>
				<div>{user.firstName + " " + user.lastName}</div>
				{user.stats?.tempo && (
					<p style={{ opacity: 0.8, fontWeight: 300, fontSize: "0.7em", lineHeight: 0.9 }}>
						Tempo: {round(user.stats.tempo.average, 1)}
					</p>
				)}
			</div>
		</Flex>
	);
};

export default function CalendarToast({ production, createSessionData, bookingUsers }) {
	const { t } = useTranslation();

	const reader = bookingUsers.find(({ id }) => id === createSessionData.reader[0]);
	const recorder = bookingUsers.find(({ id }) => id === createSessionData.recorder);

	const { totalStudioHours, completedStudioHours } = getStudioHours(production, reader);

	const [sessions] = useCollectionData(
		db.collection("sessions").where("production", "==", production.id).where("status", "==", "booked"),
	);

	const bookedStudioHours = sessions?.reduce((acc, { end, start }) => {
		return acc + (end.toDate().getTime() - start.toDate().getTime()) / 1000 / 60 / 60;
	}, 0);

	const hours = totalStudioHours
		? `${bookedStudioHours + completedStudioHours} / ${totalStudioHours}`
		: bookedStudioHours + completedStudioHours;
	const isOverbooked = bookedStudioHours + completedStudioHours > totalStudioHours;

	return (
		<Toast open style={{ width: 340 }} position="right">
			<div style={{ width: "100%" }}>
				<strong>{truncateString(production.title, 40)}</strong>

				<p style={{ margin: 0, color: themeColors.GREY, fontSize: 12 }}>
					{`${t("productionDate", "Production due date")}: ${production.productionDate
						?.toDate?.()
						.toLocaleDateString()}`}
				</p>

				<Divider style={{ margin: "5px 0" }} />

				<Flex>
					{reader && <User user={reader} />}

					{recorder && <User user={recorder} />}
				</Flex>

				<div style={{ margin: "8px 0" }}>
					<strong>{t("bookedHours", "Booked studio hours")}:</strong> {hours}{" "}
					{isOverbooked && `(${t("overbooked", "Overbooked")})`}
				</div>

				{totalStudioHours && (
					<Progress
						value={bookedStudioHours + completedStudioHours}
						total={totalStudioHours}
						color="green"
						size="small"
						style={{ margin: 0 }}
					/>
				)}
			</div>
		</Toast>
	);
}
